import { db } from '../firebase';
import { collection, doc, getDocs, setDoc, deleteDoc } from 'firebase/firestore';
import { auth } from '../firebase';

// Get all cart items for the current user
export async function getCart() {
  const user = auth.currentUser;
  // Getting cart for current user
  if (!user) throw new Error('Not authenticated');
  
  try {
    const cartRef = collection(db, 'users', user.uid, 'cart');
    // Fetching cart for user
    const snapshot = await getDocs(cartRef);
    const items = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    console.log('✅ Cart items fetched successfully from Firestore');
    return items;
  } catch (error) {
    console.warn('⚠️ Could not fetch cart from Firestore (permissions issue):', error.message);
    // Return empty array if we can't fetch from Firestore
    // This allows the cart to work even with permission issues
    return [];
  }
}

// Add or update a cart item (by id)
export async function addOrUpdateCartItem(item) {
  const user = auth.currentUser;
  // Adding or updating cart item
  if (!user) throw new Error('Not authenticated');
  
  try {
    const itemRef = doc(db, 'users', user.uid, 'cart', String(item.id));
    await setDoc(itemRef, item, { merge: true });
    console.log('✅ Cart item added/updated successfully in Firestore');
  } catch (error) {
    console.warn('⚠️ Could not save cart item to Firestore (permissions issue):', error.message);
    // Don't throw - we'll still update local state
    // This allows the cart to work even with permission issues
  }
}

// Remove a cart item by id
export async function removeCartItem(itemId) {
  const user = auth.currentUser;
  // Removing cart item
  if (!user) throw new Error('Not authenticated');
  
  try {
    const itemRef = doc(db, 'users', user.uid, 'cart', String(itemId));
    await deleteDoc(itemRef);
    console.log('✅ Cart item removed successfully from Firestore');
  } catch (error) {
    console.warn('⚠️ Could not remove cart item from Firestore (permissions issue):', error.message);
    // Don't throw - we'll still update local state
    // This allows the cart to work even with permission issues
  }
} 